import { render, staticRenderFns } from "./orgcampusinfo.vue?vue&type=template&id=d587a652&scoped=true"
import script from "./orgcampusinfo.vue?vue&type=script&lang=js"
export * from "./orgcampusinfo.vue?vue&type=script&lang=js"
import style0 from "./orgcampusinfo.vue?vue&type=style&index=0&id=d587a652&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d587a652",
  null
  
)

export default component.exports